import { Button, Space } from "antd"
import { Pixel, PixelEntry } from "domains/managingJson/store/types"
import { FC } from "react"
import { PixelEditRow } from "./PixelEditRow"

type Props = {
  pixels?: PixelEntry[] | null;
  onChange: (pixels: Pixel[]) => void;
};

export const PixelsEditorV2: FC<Props> = ({ onChange, pixels }) => {
  const editablePixels: Pixel[] = (pixels || []).flatMap(pixel => {
    if (typeof pixel === "string") return [{ src: pixel }]
    if (!pixel) return []

    return [{ ...pixel, src: pixel.src || "" }]
  })

  const onChangePixel = (index: number, callback: (pixel: Pixel) => Pixel) => {
    const newPixels = [...editablePixels]
    newPixels[index] = callback(newPixels[index])
    onChange(newPixels)
  }

  const addNewPixel = () => {
    onChange([...editablePixels, { src: "" }])
  }

  const deletePixel = (index: number) => {
    const newPixels = [...editablePixels]
    newPixels.splice(index, 1)
    onChange(newPixels)
  }

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      {editablePixels.map((pixel, index) => (
        <PixelEditRow key={index} pixel={pixel} index={index} deletePixel={deletePixel} onChange={onChangePixel} />
      ))}

      <Button type="primary" onClick={addNewPixel}>
        Add new Pixel
      </Button>
    </Space>
  )
}
